import { GrpcWebFetchTransport } from '@protobuf-ts/grpcweb-transport';

import { AuthMetadataClient } from './@applied/proto/adp/services/edge_auth/proto/auth_metadata_service_pb.client';

function makeBackendUrl(): string {
  const protocol = window.location.protocol;
  const hostname = window.location.hostname;
  let url = `${protocol}//${hostname}`;
  if (window.location.port) {
    url += `:${window.location.port}`;
  }
  return url;
}

function makeGrpcWebTransport(): GrpcWebFetchTransport {
  return new GrpcWebFetchTransport({
    baseUrl: makeBackendUrl(),
    format: 'binary',
    interceptors: [],
  });
}

const authMetadataClientSingleton = new AuthMetadataClient(makeGrpcWebTransport());

export function getAuthMetadataClient(): AuthMetadataClient {
  return authMetadataClientSingleton;
}
